<template>
  <div class="card mb-2">
    <div class="card-body bg-secondary pt-2 pb-0 pl-1 pr-2">
      <b-form class="search-form" @submit.prevent="onSearch">
        <div class="d-flex">
          <div class="row align-items-center">
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="object_type" type="select2" :items="objectTypes"
                            value-field="key"
                            :label="false" :options="{placeholder: $t('Type')}" display-field="${item.text}"/>
            </div>
            <div class="input-wrapper">
              <input-widget :model="searchModel" attribute="sale_no" type="text" :label="false" :placeholder="true"/>
            </div>
            <div class="input-wrapper">
              <b-form-group class="">
                <date-range-picker
                    class="d-flex w-100"
                    @update="onDateRangeApply"
                    showWeekNumbers
                    showDropdowns
                    ref="picker"
                    :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                    v-model="dateRange">
                  <template v-slot:input="picker" style="min-width: 350px;">
                    <span v-if="!picker.startDate" class="text-muted">
                      {{ $t('Date Range') }}
                    </span>
                    <span style="font-size: 10px" v-else>
                      {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                    </span>
                  </template>
                </date-range-picker>
              </b-form-group>
            </div>

          </div>
          <div class="search-btn-wrapper">
            <b-button variant="primary" @click.prevent="onResetClick">
              <font-awesome-icon icon="undo" class="icon"/>
              {{ $t('Reset') }}
            </b-button>
            <b-button type="submit" variant="primary" class="ml-2">
              <font-awesome-icon icon="search" class="icon"/>
              {{ $t('Search') }}
            </b-button>
          </div>
        </div>
      </b-form>
    </div>
  </div>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import i18n from "@/shared/i18n";
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

  const {mapState, mapActions} = createNamespacedHelpers('setup/accounting');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "AccountingSearch",
    components: {InputWidget, DateRangePicker},
    props: {
      excludeSearchFields: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        objectTypes: [
          {key: 'settlement', text: i18n.t('Settlement'),},
          {key: 'invoice', text: i18n.t('Invoice'),},
          {key: 'receipt', text: i18n.t('Receipt'),},
          {key: 'customer', text: i18n.t('Customer'),},
          {key: 'payment', text: i18n.t('Payment'),},
        ],
        dateRange: {startDate: null, endDate: null}
      }
    },
    computed: {
      ...globalMapState({
        enableContinuousAuction: state => state.enableContinuousAuction,
      }),
      ...mapState({
        searchModel: state => state.tableData[state.tableSource].searchModel,
        extraFilters: state => state.tableData[state.tableSource].extraFilters,
      }),
    },
    methods: {
      ...mapActions(['getTableData', 'updateSearchModel', 'resetTable', 'resetTableDataPaginationPage']),
      async onSearch() {
        await this.updateSearchModel(this.searchModel);
        this.resetTableDataPaginationPage();
        this.getTableData();
      },
      onResetClick() {
        this.dateRange = {startDate: null, endDate: null};
        this.resetTable();
      },
      onDateRangeApply() {
        this.searchModel.dateRange = this.dateRange
      },
      async onCustomerSelect(customer) {
        this.updateSearchModel({customer});
      },
    },
    mounted() {
      if (this.searchModel && this.searchModel.dateRange) {
        this.dateRange = this.searchModel.dateRange;
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
